export class TemporalSmoother {
  constructor(alpha = 0.35) {
    this.alpha = alpha;
    this.state = null;
    this.frames = 0;
  }

  reset() {
    this.state = null;
    this.frames = 0;
  }

  push(probs) {
    this.frames += 1;
    if (!this.state) {
      this.state = [...probs];
    } else {
      this.state = this.state.map((value, i) => this.alpha * probs[i] + (1 - this.alpha) * value);
    }
    return this.state;
  }
}
